module.exports = __webpack_public_path__ + "static/media/tokyo-airplane.fc14e73e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/tokyo-airplane.svg
// module id = 108
// module chunks = 0